'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _redux = require('redux');
var _merge = require('lodash/merge');
var _merge2 = _interopRequireDefault(_merge);
var _paginate = require('./paginate');
var _paginate2 = _interopRequireDefault(_paginate);
var _site = require('../actions/site');
var siteActions = _interopRequireWildcard(_site);
var _ResponsiveModes = require('../constants/ResponsiveModes');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var whiteListedEntities = ['events', 'speakers', 'sponsors', 'sponsor_categories', 'workshop_categories', 'workshops', 'attendee_types', 'business_conferences', 'stand_reservations', 'stands', 'zones', 'companies', 'custom_fields', 'business_conference_participants', 'business_conference_participant_types', 'attendee_type_custom_fields', 'business_conference_profile_fields', 'stand_categories', 'pois', 'attendees', 'account_fonts'];
var currentPageId = function currentPageId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];
  switch (action.type) {
    case siteActions.SET_CURRENT_PAGE:
      return action.id;
    default:
      return state;
  }
};
var responsiveMode = function responsiveMode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _ResponsiveModes.DESKTOP;
  var action = arguments[1];
  switch (action.type) {
    case siteActions.SET_RESPONSIVE_MODE:
      return action.responsiveMode;
    default:
      return state;
  }
};
var entities = function entities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  if (action.response && action.response.entities) {
    var fetchedData = whiteListedEntities.reduce(function (result, key) {
      result[key] = action.response.entities[key];
      return result;
    }, {});
    return (0, _merge2.default)({}, state, fetchedData);
  }
  return state;
};
var pagination = (0, _redux.combineReducers)({
  events: (0, _paginate2.default)([siteActions.COMPOSER_SETTINGS_REQUEST, siteActions.COMPOSER_SETTINGS_SUCCESS, siteActions.COMPOSER_SETTINGS_FAILURE]),
  attendee_types: (0, _paginate2.default)([siteActions.COMPOSER_SETTINGS_REQUEST, siteActions.COMPOSER_SETTINGS_SUCCESS, siteActions.COMPOSER_SETTINGS_FAILURE]),
  speakers: (0, _paginate2.default)([siteActions.SPEAKERS_REQUEST, siteActions.SPEAKERS_SUCCESS, siteActions.SPEAKERS_FAILURE]),
  sponsors: (0, _paginate2.default)([siteActions.SPONSORS_REQUEST, siteActions.SPONSORS_SUCCESS, siteActions.SPONSORS_FAILURE]),
  workshops: (0, _paginate2.default)([siteActions.WORKSHOPS_REQUEST, siteActions.WORKSHOPS_SUCCESS, siteActions.WORKSHOPS_FAILURE]),
  stand_reservations: (0, _paginate2.default)([siteActions.EXHIBITORS_REQUEST, siteActions.EXHIBITORS_SUCCESS, siteActions.EXHIBITORS_FAILURE]),
  zones: (0, _paginate2.default)([siteActions.ZONES_REQUEST, siteActions.ZONES_SUCCESS, siteActions.ZONES_FAILURE]),
  stand_categories: (0, _paginate2.default)([siteActions.STAND_CATEGORIES_REQUEST, siteActions.STAND_CATEGORIES_SUCCESS, siteActions.STAND_CATEGORIES_FAILURE]),
  pois: (0, _paginate2.default)([siteActions.POIS_REQUEST, siteActions.POIS_SUCCESS, siteActions.POIS_FAILURE]),
  business_conference_participants: (0, _paginate2.default)([siteActions.PARTICIPANTS_REQUEST, siteActions.PARTICIPANTS_SUCCESS, siteActions.PARTICIPANTS_FAILURE])
});
exports.default = (0, _redux.combineReducers)({
  currentPageId: currentPageId,
  responsiveMode: responsiveMode,
  entities: entities,
  pagination: pagination
});